var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 9.279v8.812h4.5V6.087H0V9.28zm19.191.497c-.296-2.275-1.409-3.689-4.7-3.689-1.93 0-3.232.663-3.777 1.624h-.059V6.087H7.067v12.004h3.754v-5.952c0-1.568.331-3.081 2.392-3.081 2.071 0 2.224 1.789 2.224 3.191v5.842h3.86v-6.593a13.1 13.1 0 00-.106-1.722zM2.25.09C1.006.09 0 1.03 0 2.189c0 1.16 1.006 2.098 2.25 2.098 1.243 0 2.249-.938 2.249-2.098S3.493.091 2.249.091z","fill":"currentColor","fillRule":"evenodd"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 20 19","width":"20","height":"19"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
